export default __webpack_public_path__ + "static/media/template18.d135ad84.svg";